import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  ActivityDayViewDto,
  AllocationSheetsServiceProxy,
  IActivitiesWorkDay,
  IActivityDayViewDto,
} from '@shared/service-proxies/service-proxies';
import { CloneActivityModalComponent } from '@app/components/common/activities-drawer/activities-assign-panel/clone-activity-modal/clone-activity.modal.component';

@Component({
  selector: 'app-allocation-activities',
  templateUrl: './allocation-activities.component.html',
  styleUrls: ['./allocation-activities.component.less'],
})
export class AllocationActivitiesComponent
  extends AppComponentBase
  implements OnInit {
  @Input() allocationSheetId: string = null;

  @ViewChild('cloneActivityModal', { static: true })
  modal: CloneActivityModalComponent;

  activityDays: IActivitiesWorkDay[];
  allocationLoading = true;

  dataLoaded = false;

  activityData: IActivityDayViewDto = new ActivityDayViewDto();

  constructor(
    injector: Injector,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.allocationSheetId) {
      this.getEnrolledActivityDays();
    }

    this.getActivityTimesheetAllowedActions();

    abp.event.on('evt.refreshAllowedActions', () => {
      this.getActivityTimesheetAllowedActions();
    });

    abp.event.on('evt.isCompleteToBeSubmittedRefresh', (evtData) => {
      // update isCompleteToBeSubmited flag on a particullar activity for show green tick
      let val = false;
      this._allocationSheetsServiceProxy
        .getEnrolledActivityDays(this.allocationSheetId)
        .subscribe((data) => {
          data.activityDaysByWorkDay.forEach((actDay) => {
            actDay.activityDays.forEach((day) => {
              if (
                day.activityDayId === evtData.activityDayId &&
                day.activityId === evtData.activityId
              ) {
                val = day.isCompleteToBeSubmitted;
              }
            });
          });

          this.activityDays.forEach((actDay) => {
            actDay.activityDays.forEach((day) => {
              if (
                day.activityDayId === evtData.activityDayId &&
                day.activityId === evtData.activityId
              ) {
                day.isCompleteToBeSubmitted = val;
              }
            });
          });
        });
    });

    abp.event.on('evt.submittedAllocation', () => {
      this.reload();
    });
  }

  reload(): void {
    this.getEnrolledActivityDays();
    this.getActivityTimesheetAllowedActions();
  }

  getEnrolledActivityDays(): void {
    this.allocationLoading = true;
    this._allocationSheetsServiceProxy
      .getEnrolledActivityDays(this.allocationSheetId)
      .subscribe((data) => {
        this.activityDays = data.activityDaysByWorkDay;
        this.allocationLoading = false;
      });
  }

  refresh(): void {
    this.getEnrolledActivityDays();
  }

  openActivityDetailsPanel(event): void {
    abp.event.trigger('app.evt.openAssignPanel', event);
  }

  afterClone(): void {
    this.getEnrolledActivityDays();
  }

  getActivityTimesheetAllowedActions(): void {
    abp.event.trigger('evt.allowedActionsUpdate', {
      allocationSheetId: this.allocationSheetId,
    });
  }
}
